import LockIcon from '@/app/icons/lock'
import { IGif } from '@giphy/js-types'

const PrivacyOverlay = ({ gif }: { gif: IGif }) => {
    return gif.is_hidden ? (
        <div className="pointer-events-none absolute inset-0 flex select-none items-center justify-center">
            <LockIcon className="fill-giphyRed size-10" />
        </div>
    ) : null
}

export default PrivacyOverlay
